const translations = {
  PLACEHOLDER_EMAIL_OPTIONAL: {
    description: 'Email (Optional)',
    primaryValue: 'Email Address (Optional)',
    stringKey: 'PLACEHOLDER_EMAIL_OPTIONAL',
  },
  PLACEHOLDER_EMAIL_ADDRESS: {
    description: 'Email Address',
    primaryValue: 'Email Address',
    stringKey: 'PLACEHOLDER_EMAIL_ADDRESS',
  },
  PLACEHOLDER_LAST_NAME: {
    description: 'Last Name',
    primaryValue: 'Last Name',
    stringKey: 'PLACEHOLDER_LAST_NAME',
  },
  PLACEHOLDER_FIRST_NAME: {
    description: 'First Name',
    primaryValue: 'First Name',
    stringKey: 'PLACEHOLDER_FIRST_NAME',
  },
  GRID_HEADER_NAME: {
    description: 'Name',
    primaryValue: 'Name',
    stringKey: 'GRID_HEADER_NAME',
  },
  GRID_HEADER_EMAIL: {
    description: 'Email',
    primaryValue: 'Email',
    stringKey: 'GRID_HEADER_EMAIL',
  },
  GRID_HEADER_ACTIONS: {
    description: 'Actions',
    primaryValue: 'Actions',
    stringKey: 'GRID_HEADER_ACTIONS',
  },
  PASS_MODAL_VIP_INFO_HEADING: {
    description: 'VIP Information',
    primaryValue: 'VIP Info',
    stringKey: 'PASS_MODAL_VIP_INFO_HEADING',
  },
  GRID_EMPTY_TEXT_VIP: {
    description: 'No VIPs added',
    primaryValue: 'No VIPs added...',
    stringKey: 'GRID_EMPTY_TEXT_VIP',
  },
  PASS_MODAL_REGISTER: {
    description: 'Register',
    primaryValue: 'Register',
    stringKey: 'PASS_MODAL_REGISTER',
  },
  TOASTR_PASS_ADDED: {
    description: 'Pass Added',
    primaryValue: '{{passType}} pass added',
    stringKey: 'TOASTR_PASS_ADDED',
  },
  TOASTR_PASS_ERROR: {
    description: 'Pass Error',
    primaryValue: 'There was an error adding your pass.',
    stringKey: 'TOASTR_PASS_ERROR',
  },
  DDL_STORE_SELECT: {
    description: 'Select Store',
    primaryValue: 'Select Store',
    stringKey: 'DDL_STORE_SELECT',
  },
  PASS_MODAL_UPDATE: {
    description: 'Update',
    primaryValue: 'Update',
    stringKey: 'PASS_MODAL_UPDATE',
  },
};

export default translations;
